import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OnboardingWorkflow = ({ candidates }) => {
  const onboardingSteps = [
    { id: 1, title: 'Document Verification', icon: 'FileText', status: 'completed' },
    { id: 2, title: 'Background Check', icon: 'Shield', status: 'completed' },
    { id: 3, title: 'Role Provisioning', icon: 'UserCog', status: 'in_progress' },
    { id: 4, title: 'System Access Setup', icon: 'Key', status: 'pending' },
    { id: 5, title: 'Training Assignment', icon: 'BookOpen', status: 'pending' },
    { id: 6, title: 'Onboarding Complete', icon: 'CheckCircle', status: 'pending' }
  ];

  const getStepColor = (status) => {
    switch (status) {
      case 'completed': return 'success';
      case 'in_progress': return 'secondary';
      case 'pending': return 'muted';
      default: return 'muted';
    }
  };

  return (
    <div className="glass-container rounded-xl border border-border/50">
      <div className="p-6 border-b border-border/50">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Onboarding Workflow</h3>
            <p className="text-sm text-muted-foreground mt-1">
              {candidates?.length || 0} candidates in onboarding
            </p>
          </div>
          <Button variant="outline" size="sm" iconName="Settings">
            Configure Workflow
          </Button>
        </div>
      </div>
      <div className="p-6">
        {candidates?.length === 0 ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 rounded-full bg-muted/10 flex items-center justify-center mx-auto mb-4">
              <Icon name="Users" size={32} className="text-muted-foreground" />
            </div>
            <h4 className="text-lg font-semibold text-foreground mb-2">No Active Onboarding</h4>
            <p className="text-sm text-muted-foreground">
              No candidates currently in onboarding process
            </p>
          </div>
        ) : (
          <div className="space-y-6">
            {candidates?.map((candidate) => (
              <div key={candidate?.id} className="p-4 rounded-lg border border-border/50 bg-muted/5">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
                      <Icon name="User" size={18} color="white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground">{candidate?.name}</h4>
                      <p className="text-sm text-muted-foreground">{candidate?.militaryBranch} • {candidate?.rank}</p>
                    </div>
                  </div>
                  <Button variant="ghost" size="sm" iconName="Eye">
                    View Details
                  </Button>
                </div>

                {/* Progress Bar */}
                <div className="mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-muted-foreground">Onboarding Progress</span>
                    <span className="text-sm font-bold text-foreground">33%</span>
                  </div>
                  <div className="w-full h-2 bg-muted/20 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-secondary to-accent transition-all duration-500"
                      style={{ width: '33%' }}
                    />
                  </div>
                </div>

                {/* Onboarding Steps */}
                <div className="space-y-2">
                  {onboardingSteps?.map((step, index) => (
                    <div
                      key={step?.id}
                      className={`flex items-center justify-between p-3 rounded-lg border ${
                        step?.status === 'completed'
                          ? 'border-success/20 bg-success/5'
                          : step?.status === 'in_progress' ?'border-secondary/20 bg-secondary/5' :'border-border/50 bg-muted/5'
                      }`}
                    >
                      <div className="flex items-center space-x-3">
                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center border text-${getStepColor(step?.status)} bg-${getStepColor(step?.status)}/10 border-${getStepColor(step?.status)}/20`}>
                          <Icon name={step?.icon} size={16} />
                        </div>
                        <span className="text-sm font-medium text-foreground">{step?.title}</span>
                      </div>
                      {step?.status === 'completed' && (
                        <Icon name="CheckCircle" size={16} className="text-success" />
                      )}
                      {step?.status === 'in_progress' && (
                        <span className="px-2 py-1 rounded text-xs font-medium text-secondary bg-secondary/10">
                          IN PROGRESS
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OnboardingWorkflow;